export default __webpack_public_path__ + "static/media/FD2.c2a8946e.png";